<p-dialog #dialog appendTo="body" header="Enable/Disable Port" [(visible)]="visible" [modal]="true"
		  [resizable]="false" styleClass="single-port-status-dialog" (onHide)="onHide()"
		  [style]="{'width': '500px'}">

	<single-port-enable-disable-editor [deviceGuid]="deviceGuid" [ifIndex]="ifIndex" [visible]="visible">
	</single-port-enable-disable-editor>

	<p-footer>
		<button type="button" pButton icon="fa fa-times" [disabled]="false"
				(click)="onCloseClicked()" label="Close"></button>
	</p-footer>

</p-dialog>
